import { makeStyles } from "@material-ui/core/styles";
import ultrasound from "assets/ultrasound-photo.jpg";

export const useStyles = makeStyles((theme) => ({
  homeWrapper: {
      width: '100%'
  },
  mainFeatured: {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    backgroundImage: "url(" + ultrasound + ")",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  howItWorksHook: {
    position: 'absolute',
    top: '-80px',
  },
  bannerHeader: {
    color: "black", 
    fontSize: "40px", 
    lineHeight: "50px",
    width: '400px',
    "@media (max-width: 600px)": {
      width: '90%',
      margin: '0 auto'
    }
  },
  mainFeaturedContent: {
    paddingLeft: 150,
    paddingTop: 130,
    paddingBottom: 80,
    background: 'linear-gradient(90deg, rgba(255,255,255,1) 39%, rgba(0,212,255,0) 100%)',
    position: "relative",
    display: 'flex',
    flexDirection: 'column',
    '& button': {
      width: 280,
      marginBottom: 20
    },
    "@media (max-width: 600px)": {
      alignContent: 'center',
      paddingLeft: 0,
      width: '100%',
      textAlign: 'center',
      '& button': {
        margin: '15px auto'
      } 
    }
  },
  howItWorks: {
    width: '100%',
    padding: 90,
    backgroundColor: 'white',
    position: 'relative',
    "@media (max-width: 1100px)": {
      padding: '90px 0 90px 0'
    },
    "@media (max-width: 640px)": {
      padding: 90
    }
  }
}));